import makeStyles from '@mui/styles/makeStyles';

const useLoadingScreenStyles = makeStyles({
  loading: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

export default useLoadingScreenStyles;
